// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import MUINavBar from "../../components/MUINavBar/MUINavBar";
import MDBox from "../../components/MDBox";
import DetailedFooter from "../../pageSections/detailedFooter";
import colors from "../../assets/theme/base/colors";
import MKTypography from "../../components/MKTypography";
import {
  Backdrop,
  Button,
  Card,
  CircularProgress,
  FormLabel,
  InputLabel,
  Stack,
} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import ShieldIcon from "@mui/icons-material/Shield";
import ShieldTwoToneIcon from "@mui/icons-material/ShieldTwoTone";
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone";
function AuthenticationCardLayout({ title, subtitle, loading, children }) {
  return (
    <Grid container py={8} alignItems="center" flexDirection="column">
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox>
            <MDBox mb={0} pb={2}>
              <Stack direction="row">
                <MDBox alignItems="center" display="flex" pr={"0.3rem"}>
                  <LockTwoToneIcon
                    fontSize="medium"
                    sx={{ color: colors.JTCElectricBlue }}
                  />
                </MDBox>

                <InputLabel
                  sx={{
                    lineHeight: "2px",
                    whiteSpace: "unset",
                  }}
                >
                  <MDTypography fontWeight="medium" variant="subtitle1">
                    {title}
                  </MDTypography>
                </InputLabel>
              </Stack>
              <InputLabel
                sx={{
                  paddingTop: "0.3rem",
                  paddingBottom: subtitle == "" ? "1.2rem" : "1.5rem",
                  maxWidth: "90vw",
                  whiteSpace: "unset",
                  wordBreak: "break-all",
                }}
              >
                {subtitle}
              </InputLabel>
            </MDBox>

            {children}
            <MDBox
              sx={{
                minHeight: "1.5rem",
              }}
            ></MDBox>
          </MDBox>
        </MDBox>
      </Card>

      <Backdrop
        sx={{
          color: colors.JTCElectricBlue,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  );
}

AuthenticationCardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

AuthenticationCardLayout.defaultProps = {
  loading: false,
  subtitle: "",
  title: "",
};
export default AuthenticationCardLayout;
